import { createContext } from 'react';

const CuponesContext = createContext();

export default CuponesContext;
